// extracted by mini-css-extract-plugin
export default {"navigationMenu":"navigation_navigationMenu__bRm4x","navigationMenuItem":"navigation_navigationMenuItem__wOg2b","selected":"navigation_selected__t3ZyI"};